<template lang="pug">
  div
    v-fade-transition(leave-absolute)
      div(
        v-if="fileName && fileUrl"
        style="width: 100%"
        color="transparent"
        flat
      )
        .caption {{label}}
        v-card(
          style="width: 100%"
          color="transparent"
          flat
        ).d-inline-flex.align-center.justify-center.pa-2
          image-dialog(
            v-if="isImage(fileName)"
            :url="fileUrl"
            :title="fileName.substring(20)"
          )
          v-btn(
            v-else
            large
            rounded
            :href="fileUrl"
            target="_blank"
            text
          )
            v-icon.mr-4(
              color="secondary"
              left
              large
            ) mdi-attachment
            | {{ fileName.substring(20) }}
          v-btn(
              color="red"
              @click="removeFile" icon
          )
            v-icon(color="error") mdi-close
    validation-provider(
      ref="provider"
      v-slot="{ errors, valid }"
      :rules="rules"
      :name="name"
      :vid="vid"
    )
      div(v-show="!invisible")
        div(v-show="!(fileName && fileUrl)")
          v-file-input(
            v-show="!file || errors.length"
            name="file_name"
            ref="uploader"
            :label="label"
            :error-messages="errors"
            :hint="hint"
            prepend-inner-icon="mdi-paperclip"
            prepend-icon=""
            v-bind="$attrs"
            persistent-hint
            @change="selectFile"
          )
          v-fade-transition(leave-absolute)
            .mb-2.mx-2(v-if="progress")
              .caption Загрузка файла...
              v-progress-linear(
                :value="progress"
                color="secondary"
                height="3"
                rounded
              )
      slot(v-bind="{ progress, errors, pickfile }")
</template>

<script>
import SystemService from '@/services/API/SystemService';
import APIService from '@/services/APIService';
import ImageDialog from '@/components/Global/ImageDialog.vue';

export default {
  name: 'FileUpload',
  components: {
    ImageDialog,
  },
  props: {
    rules: {
      type: String,
      default: '',
    },
    vid: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'Файл',
    },
    label: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    existingFileName: {
      type: String,
      default: '',
    },
    existingFileUrl: {
      type: String,
      default: '',
    },
    inputTitle: {
      type: String,
      default: '',
    },
    invisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      file: '',
      fileName: this.existingFileName,
      fileUrl: this.existingFileUrl,
      progress: 0,
    };
  },
  watch: {
    existingFileName(val) {
      this.fileName = val;
    },
    existingFileUrl(val) {
      this.fileUrl = val;
    },
  },
  methods: {
    pickfile() {
      this.$refs.uploader.$refs.input.click();
    },
    isImage(url) {
      return ['png', 'jpg'].includes(url.substr(-3));
    },
    selectFile(file) {
      if (!file) {
        this.file = '';
      } else {
        this.file = file;
      }
      this.$emit('file:changed', file);
    },
    removeFile() {
      this.fileName = '';
      this.fileUrl = '';
      this.selectFile('');
    },
    /**
     * Загружает файл на сервер, возвращает имя файла
     * @returns {Promise<unknown>}
     */
    uploadFile() {
      this.$refs.provider.reset();
      return new Promise((resolve, reject) => {
        if (!this.file) {
          resolve(null);
          return;
        }

        const CHUNK_SIZE = 500 * 1024;
        const fileSize = this.file.size;

        if (fileSize < CHUNK_SIZE) {
          this.uploadSingle(resolve, reject);
        } else {
          this.uploadChunked(resolve, CHUNK_SIZE, fileSize);
        }
      });
    },
    async uploadChunked(resolve, chunkSize, fileSize) {
      this.progress = 0;
      const dispositionName = Math.random().toString(32);
      const chunksCount = Math.ceil(fileSize / chunkSize);
      let response;
      for (let start = 0; start < fileSize; start += chunkSize) {
        const data = new FormData();
        data.append('file', this.file.slice(start, start + chunkSize), dispositionName);
        try {
          // eslint-disable-next-line no-await-in-loop
          response = await APIService.post('/uploads', data, {
            headers: {
              'Content-Type': 'application/octet-stream',
              Accept: 'application/json',
              'Content-Disposition': `attachment; filename=${dispositionName}`,
              'Content-Range': `bytes ${start}-${start + chunkSize}/${fileSize}`,
            },
          });
          this.progress += Math.ceil(100 / chunksCount);
        } catch (e) {
          console.log(e);
        }
      }
      this.progress = 0;
      resolve(response.data.data);
    },
    uploadSingle(resolve, reject) {
      const formData = new FormData();
      formData.append('file', this.file);
      this.$rHandler(
        SystemService.uploadFiles(formData),
        (r) => resolve(r.data.data),
        (e) => {
          console.log('Ошибка в FileUpload', e);
          this.$toasted.error('Не удалось загрузить файл', {
            duration: 2000,
          });
          this.$refs.provider.setErrors(e.response.data.validation.file);
          reject(e.response.data);
        },
      );
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
